<script lang="ts">
  import type { Snippet } from "svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import {
    SCHEDULING_ACTION_TOOLTIP_CLASS,
    schedulingActionTooltips,
  } from "../../../../../../../../../../../_shared/_logic/action-tooltips"
  import StepActionCTA from "../../../../../../../../../_shared/_modules/step-action-cta"
  import type {
    CancelAppointmentsIntent,
    CancelAppointmentsOperations,
    CancelAppointmentsPhase,
    CancelAppointmentsResult,
  } from "../../actions/cancelAppointments"
  import { projectCancelAppointmentsOutcome } from "./project-cancel-appointments-outcome"

  type Props = {
    children?: Snippet<[Snippet]>
    intent: CancelAppointmentsIntent
    operations: CancelAppointmentsOperations
    onSubmissionResult: (result: CancelAppointmentsResult) => Promise<void> | void
    onPhaseChange?: (phase: CancelAppointmentsPhase) => void
  }

  const {
    children = null,
    intent,
    operations,
    onSubmissionResult,
    onPhaseChange = () => {},
  }: Props = $props()

  let pending = $state(false)

  const run = async () => {
    if (pending) return

    if (intent.kind === "blocked") {
      newNotification({ class: "error", html: intent.message })

      return
    }

    pending = true
    onPhaseChange("canceling")
    let committed = false
    try {
      const response = await operations.cancelAppointments(intent.eventIds)
      committed = true
      const output = projectCancelAppointmentsOutcome({ rows: intent.rows, response })
      try {
        await onSubmissionResult({ kind: "committed", output })
      } catch (error) {
        console.error("cancel_replan_cancel_completion_failed", error)
        newNotification({
          class: "error",
          html: "Änderung gespeichert, Oberfläche konnte nicht aktualisiert werden.",
        })
      }
    } catch (error) {
      console.error("cancel_replan_cancel_failed", error)
      newNotification({
        class: "error",
        html: committed
          ? "Änderung gespeichert, Oberfläche konnte nicht aktualisiert werden."
          : "Termine konnten nicht storniert werden.",
      })
    } finally {
      pending = false
      onPhaseChange("idle")
    }
  }
</script>

{#snippet primaryAction()}
  <StepActionCTA
    type="primaryButton"
    content={pending ? "Termine werden storniert…" : intent.label}
    tooltipContent={schedulingActionTooltips.cancelReplanCancelEvents}
    tooltipClassName={SCHEDULING_ACTION_TOOLTIP_CLASS}
    disabled={pending || intent.disabled}
    disabledReason={pending ? "Termine werden gerade storniert." : intent.disabledReason}
    onClick={run}
  />
{/snippet}

{#if children}
  {@render children(primaryAction)}
{:else}
  {@render primaryAction()}
{/if}
